<template>
    <div>
        <az-break-title title="Profissionais" />

        <div>

            <div class="row mb-3">
                <div class="col col-12">
                    <az-input icon="fas fa-search" v-model="search" />
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column" v-if="1 == 0">
                    <button type="button" class="btn btn-outline-success" @click="incluir ()">
                        Adicionar Regra
                    </button>
                </div>
            </div>

        </div>

        <div v-if="!lista || !lista.length">
            <az-empty-state icon="fas fa-search" msg="Nenhuma operadora identificada." 
                :action="!search ? 'Incluir Operadora' : ''" :method="incluir" />
		</div>

        <div v-if="lista && lista.length">

            <div class="mb-3">
                <button type="button" class="btn btn-outline-primary btn-sm mr-1" @click="enableAll(true)">Habilitar Todos</button>
                <button type="button" class="btn btn-outline-danger btn-sm" @click="enableAll(false)">Desabilitar Todos</button>
            </div>

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex flex-column" 
                    v-for="(dado, id) in lista" :key="id">
                    <div class="d-flex justify-content-between">
                        <span>
                            <a @click.prevent="editar_codigo(dado)" href="#" class="h5 card-link mb-0 mr-3">
                                {{ dado.search }}
                            </a>
                            <span class="badge badge-secondary" v-if="dado.medico_operadora && dado.medico_operadora.st_codigo">
                                {{ dado.medico_operadora.st_codigo }}
                            </span>
                        </span>
                        <span class="d-flex">
                            <div v-if="dado.js_classes" class="mr-2">
                                <a href="#" @click.prevent="pesquisar(classe)" v-for="(classe, icx) in dado.js_classes" :key="icx">
                                    <span class="badge badge-success mr-1">
                                        {{ classe }}
                                    </span>
                                </a>
                            </div>
                            <div>
                                <span class="badge badge-secondary mr-3" v-if="dado.medico_operadora && dado.medico_operadora.medico_operadora_regras && dado.medico_operadora.medico_operadora_regras.length">
                                    <a @click.prevent="1 == 0" class="card-link text-white"
                                        data-toggle="collapse" :href="'#collapse-' + id" role="button">
                                        {{ dado.medico_operadora.medico_operadora_regras.length }}
                                    </a>
                                </span>
                                <span v-if="dado.medico_operadora.fl_ativo && 1 == 0">
                                    <a href="#" class="card-link" @click.prevent="incluir(dado)">
                                        <i class="fas fa-plus text-success mr-3"></i>
                                    </a>
                                </span>
                            </div>
                            <div class="custom-control custom-switch" v-if="dado.medico_operadora">
                                <input type="checkbox" class="custom-control-input" :id="'ativo-' + id" 
                                    v-model="dado.medico_operadora.fl_ativo" 
                                    @change="toggle(dado.medico_operadora)">
                                <label class="custom-control-label" :for="'ativo-' + id"></label>
                            </div>
                        </span>
                    </div>
                    <div class="collapse" :id="'collapse-' + id"> 
                        <div v-if="dado.medico_operadora && dado.medico_operadora.medico_operadora_regras && dado.medico_operadora.medico_operadora_regras.length"> 
                            <az-sub-title title="Regras" />
                            <div class="list-group">
                                <li class="list-group-item" v-for="(dado_regra, idr) in dado.medico_operadora.medico_operadora_regras" :key="idr">
                                    <a href="#" @click.prevent="editar(dado, dado_regra)" class="card-link">
                                        {{ dado_regra.search }} 
                                    </a>
                                </li>
                            </div>
                        </div>
                        <div v-else-if="false">
                            Nenhuma regra registrada para esse profissional.
                        </div>
                        <pre v-if="1 == 0">{{ dado.medico_operadora ? dado.medico_operadora.medico_operadora_regras : '' }}</pre>
                    </div>
                </li>
            </div>

        </div>

        <br><br>

        <pre v-if="1 == 0">{{ dados }}</pre>

        <!-- Modal -->
        <div class="modal fade" id="regraModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            Regra para Profissional
                            {{ regra && !regra.id_medico_operadora_regra ? '(Nova)' : '' }}
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="regra">
                        <div class="row">
                            <div class="col col-12">
                                <az-sub-title :big="true" :title="regra.search" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-12">
                                <az-input 
                                    label="Título"
                                    :validate="validate"
                                    v-model="regra.st_titulo" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-12 col-md-6">
                                <az-input 
                                    label="Prestador a Faturar"
                                    type="select"
                                    optionsMode="aql"
                                    :optionsSync="false"
                                    service="medico_operadoras.index"
                                    optionsData="id_medico_operadora"
                                    optionsDisplay="search"
                                    :optionsParm="{ where: { id_operadora: this.id_operadora, fl_ativo: true } }"
                                    optionsName="medicos-regra"
                                    :optionsReload="true"
                                    :validate="validate"
                                    required
                                    v-model="regra.id_medico_operadora_fatura" />
                            </div>
                            <div class="col col-12 col-md-6">
                                <az-input 
                                    label="Tipo de Faturamento"
                                    type="button-group"
                                    :optionsList="[{ id: 'E', search: 'Empresa'}, { id: 'P', search: 'Profissional'}]"
                                    required 
                                    :validate="validate"
                                    v-model="regra.ch_faturamento" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-12 col-md-6">
                                <az-input 
                                    label="Código na Operadora"
                                    :validate="validate"
                                    v-model="regra.st_plano_contrato" />
                            </div>
                            <div class="col col-12 col-md-6">
                                <az-input 
                                    label="Nome do Contratado"
                                    :validate="validate"
                                    v-model="regra.st_contratado_nome" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-12 col-md-6">
                                <az-input 
                                    label="CNES"
                                    :validate="validate"
                                    v-model="regra.st_contratado_cnes" />
                            </div>
                        </div>

                        <filtro-model v-model="regra.filtros" :validate="validate" :opcoes="lista_opcoes_filtro" />

                        <template v-if="regra.id_plano || regra.id_classe_procedimento || regra.id_procedimento">
                            <az-sub-title title="Escopo" />
                            <div class="row">
                                <div class="col col-12 col-md-6">
                                    <az-input 
                                        label="Plano"
                                        type="select"
                                        optionsMode="aql"
                                        :optionsSync="false"
                                        service="planos.index"
                                        optionsData="id_plano"
                                        optionsDisplay="search"
                                        optionsName="planos-regra"
                                        :optionsReload="true"
                                        :optionsParm="{ where: { id_operadora: this.id_operadora } }"
                                        :validate="validate"
                                        v-model="regra.id_plano" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col col-12 col-md-6">
                                    <az-input 
                                        label="Classificação"
                                        service="classe_procedimentos.index"
                                        type="select"
                                        optionsMode="aql"
                                        :optionsSync="false"
                                        optionsData="id_classe_procedimento"
                                        optionsDisplay="search"
                                        :validate="validate"
                                        :edicao="!regra.id_procedimento"
                                        v-model="regra.id_classe_procedimento" />
                                </div>
                                <div class="col col-12 col-md-6">
                                    <az-input 
                                        label="Procedimento"
                                        :validate="validate"
                                        type="autocomplete"
                                        service="procedimentos.index"
                                        optionsData="id_procedimento"
                                        optionsDisplay="search"
                                        :edicao="!regra.id_classe_procedimento"
                                        v-model="regra.id_procedimento" />
                                </div>
                            </div>
                        </template>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-outline-secondary mr-2" 
                            @click="$util.logAudit('medicoOperadoraRegra', regra.id_medico_operadora_regra)"
                            v-if="regra && regra.id_medico_operadora_regra">
                            Log
                        </button>
                        <az-submit color="outline-danger" @click="remover ()" v-if="regra && regra.id_medico_operadora_regra">
                            Remover
                        </az-submit>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Edição Código -->
        <div class="modal fade" id="codigoPrestadorModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content" v-if="edicao">
                    <div class="modal-header">
                        <h5 class="modal-title">Profissional</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-info">
                            {{ edicao.search }}
                        </div>

                        <az-input
                            type="text"
                            label="Código na Operadora"
                            placeholder="CPF..."
                            v-model="edicao.medico_operadora.st_codigo" />

                        <az-sub-title title="Códigos por Unidade" class="mt-3">
                            <a href="#" @click.prevent="incluir_codigo_unidade()" class="card-link">
                                <i class="fa fa-plus" aria-hidden="true"></i>
                            </a>
                        </az-sub-title>
                        <template v-for="(codigo, idx) in edicao.medico_operadora.js_outros">
                            <div class="form-row" :key="idx">
                                <div class="col col-12 col-md-6">
                                    <az-input 
                                        sizing="sm" 
                                        type="select" 
                                        placeholder="Unidade..."
                                        :optionsList="$util.unidades_com_tags(false, true)"
                                        optionsData="id_unidade_operacao"
                                        v-model="codigo.id_unidade_operacao"
                                    >
                                        <template v-slot:button-pre>
                                            <div class="input-group-prepend">
                                                <button class="btn btn-outline-danger" type="button"
                                                    @click="remover_codigo_unidade(idx)">
                                                    <i class="fa fa-minus" aria-hidden="true"></i>
                                                </button>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-6">
                                    <az-input sizing="sm" type="text" placeholder="Código..."
                                        v-model="codigo.st_codigo" />
                                </div>
                            </div>
                        </template>
                        <a href="#" @click.prevent="incluir_codigo_unidade()" class="btn btn-outline-primary btn-sm mt-1">
                            <i class="fa fa-plus" aria-hidden="true"></i>
                        </a>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar_profissional ()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzBreakTitle from '../../../util/AzBreakTitle.vue';
import AzEmptyState from '../../../util/AzEmptyState.vue';
import AzInput from '../../../shared/forms/AzInput.vue';
import AzSubTitle from '../../../util/AzSubTitle.vue';
import AzSubmit from '../../../util/AzSubmit.vue';
import FiltroModel from '../../shared/FiltroModel.vue';

export default {
    data () { 
        return { 
            dados: null, 
            search: "",
            validate: false, 
            regra: null,  
            edicao: null, 
        }
    },

    components: { 
        AzBreakTitle,
        AzEmptyState,
        AzInput,
        AzSubTitle,
        AzSubmit,
        FiltroModel
    }, 

    props: ['id_operadora'],

    computed: { 
        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados && this.dados.length ? 
                this.dados.filter (item => { 
                    return !this.search || reg.test(JSON.stringify(item));
                }).map (item => { 
                   if ( !item.medico_operadora ) { 
                       item.medico_operadora = { 
                           id_medico_operadora: null, 
                           id_medico: item.id_pessoa, 
                           id_operadora: this.id_operadora,
                           fl_ativo: false, 
                       };
                   }

                   return item;
                }) : null ; 
        },

        lista_opcoes_filtro: function () { 
            let opcoes = [                                
                {id:'App\\azure\\classeProcedimento', search:'Classe do Procedimento', service: 'classe_procedimentos.index'}, 
                {id:'App\\azure\\especialidade', search:'Especialidade', service: 'especialidades.index'}, 
                {id:'App\\azure\\plano', search:'Operadora/Plano', service: 'planos.index', nosync: true}, 
                {id:'App\\azure\\procedimento', search:'Procedimento', service: 'procedimentos.index'},
            ];

            if ( this.regra && !this.regra.id_medico_operadora ) { 
                opcoes.push({id:'App\\azure\\medico', search:'Prestador', service: 'medicos.index'});
            }
            
            if ( this.$store.state.unidade.unidade_operacaos.length > 1 ) { 
                opcoes.push({id:'App\\azure\\unidadeOperacao', search:'Unidade',service:'unidade_operacaos.index'});
            }
            
            return _.orderBy(opcoes, 'search');
        },
    },

    methods: { 
        pesquisar (texto) { 
            if ( this.search == '"' + texto + '"' ) { 
                this.search = '';
            } else { 
                this.search = '"' + texto + '"';
            }
        },

        enableAll(habilitar) { 

            let query = { q: [] };

            this.lista.forEach((element, key) => {
               if ( element.medico_operadora.fl_ativo != habilitar ) {   
                    element.medico_operadora.fl_ativo = habilitar;

                    query.q.push( 
                    { 
                        name: 'medico_operadoras.toggle',
                        id: key,
                        parms: { 
                            ...element.medico_operadora,
                            incluir: true, 
                        }
                    });
               }
            });

            if ( query.q.length ) { 

                this.axios.post('/aql', query)
                    .then(res => { 
                        this.lista.forEach((element, key) => {
                            if ( res.data[key] && res.data[key].status == 200 ) { 
                                if ( !element.id_medico_operadora )
                                    element.id_medico_operadora = res.data[key].data.id_medico_operadora;
                            }
                        });
                    })
                    .finally(() => { 
                        this.$store.commit('loading', false);
                    });

            }

            
        },

        toggle (item) { 
            
            this.$store.commit('loading', true);

            let query = { q: [ 
                { 
                    name: 'medico_operadoras.toggle',
                    id: 'toggle',
                    parms: { 
                        ...item,
                        incluir: true, 
                    }
                }
            ]};

            this.axios.post('/aql', query)
                .then(res => { 
                    if ( res.data.toggle.status == 200 ) { 
                        if ( !item.id_medico_operadora )
                            item.id_medico_operadora = res.data.toggle.data.id_medico_operadora;
                    }
                })
                .finally(() => { 
                    this.$store.commit('loading', false);
                });

        },

        remover () { 

            if ( confirm ('Confirma remover essa regra?') ) { 

                this.$store.commit('loading', true);

                    let query = { q: [ 
                        {
                            name: 'medico_operadora_regras.destroy',
                            id: 'atualizar',
                            parms: { 
                                id_medico_operadora_regra: this.regra.id_medico_operadora_regra,
                            }
                        }
                    ]};

                    this.axios.post('/aql', query)
                        .then(res => { 
                            if ( res.data.atualizar.status == 200 ) { 
                                this.load ();
                                $('#regraModal').modal('hide');
                            }
                        })
                        .finally(() => { 
                            this.$store.commit('loading', false);
                        });

            }

        },

        atualizar () { 

            this.validate = true;

            this.$nextTick (() => { 

                let invalids = $('.invalid');

                if ( invalids.length ) { 
                
                    this.$toast.add({
                        severity: "error",
                        summary: "Atenção",
                        detail: "Verificar preenchimento dos campos.",
                        life: 3000
                    });

                } else { 

                    this.$store.commit('loading', true);

                    let query = { q: [ 
                        {
                            name: 'medico_operadora_regras.store',
                            id: 'atualizar',
                            parms: { 
                                ...this.regra,
                            }
                        }
                    ]};

                    this.axios.post('/aql', query)
                        .then(res => { 
                            if ( res.data.atualizar.status == 200 ) { 
                                this.load ();
                                $('#regraModal').modal('hide');
                            }
                        })
                        .finally(() => { 
                            this.$store.commit('loading', false);
                        });

                }

            });

        },

        incluir_codigo_unidade () {
            if (!this.edicao.medico_operadora.js_outros) {
                this.$set(this.edicao.medico_operadora, 'js_outros', []);
            }
            this.edicao.medico_operadora.js_outros.push({
                id_unidade_operacao: null,
                st_codigo: '',
            });
        },

        remover_codigo_unidade (idx) {
            this.edicao.medico_operadora.js_outros.splice(idx, 1);
        },

        editar_codigo (medico) { 

            if ( !medico.medico_operadora || !medico.medico_operadora.fl_ativo ) { 
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: 'Profissional não ativo: ' + medico.search,
                    life: 3000
                });
                return;
            }

            this.validate = false;
            this.edicao = _.cloneDeep(medico);

            if (!this.edicao.medico_operadora.js_outros) {
                this.$set(this.edicao.medico_operadora, 'js_outros', []);
            }

            $('#codigoPrestadorModal').modal('show');

        },  

        atualizar_profissional () { 
            this.$util.atualizar (this, { 
                service: 'medico_operadoras',
                func: 'store',
                dados: this.edicao.medico_operadora,
                modal: 'codigoPrestadorModal',
                reload: true, 
            });
        },

        editar (medico, regra) { 

            this.validate = false;

            this.regra = null; 

            this.$nextTick(() => { 

                this.regra = {
                    ...regra
                };

                this.regra.search = medico.search;
                
                $('#regraModal').modal('show');

            });

        },

        incluir (medico) { 

            this.validate = false;

            this.regra = null; 

            this.$nextTick(() => { 

                this.regra = {
                    id_operadora: this.id_operadora,
                    id_medico_operadora: medico.medico_operadora.id_medico_operadora,
                    id_medico_operadora_fatura: medico.medico_operadora.id_medico_operadora,
                    id_classe_procedimento: null, 
                    ch_faturamento: 'E',
                    st_plano_contrato: "", 
                    search: medico.search, 
                    filtros: [], 
                };

                $('#regraModal').modal('show');

            });

        },

        load () { 
            this.validate = false;

            this.$store.commit('loading', true);

            let query = { q: [ 
                {
                    name: 'medicos.index',
                    id: 'medicos',
                    parms: { 
                        cadastro_operadora: true,
                        id_operadora: this.id_operadora,
                    }
                }
            ]};

            this.axios.post('/aql', query)
                .then(res => { 
                    if ( res.data.medicos.status == 200 ) { 
                        this.dados = res.data.medicos.data;
                    }
                })
                .finally(() => { 
                    this.$store.commit('loading', false);
                });
        }
    },

    mounted () { 
        this.load ();
    }
}
</script>
